/**
 * The catalog is a mutable file and its tier names have already been reworked
 * once (`basic`/`premium` became `visibilite`/`reservation`). Payments and
 * subscription records snapshot the name they were created with, so a stored
 * tier can outlive its copy.
 *
 * Pair this with `defaultValue: tier` at the call site: a tier the catalog no
 * longer sells then reads as its raw name rather than as a raw translation key.
 */
export const tierTitleKey = (tier: string): string =>
  `landingPage.subscriptionTiers.tiers.${tier}.title`;
